<template>
  <div class="content">
    <lottery
      :first="state.first"
      :cjnum="state.cjnum"
      @scrollTofirst="scrollTofirst"
      @subtractCjnum="subtractCjnum"
    ></lottery>
    <task
      :taskList="state.taskList"
      :signreward="state.signReward"
      :nowDay="state.nowday"
      @reloadTask="reloadTask"
      @updateCjnum="updateCjnum"
      @updateTaskStatus="updateTaskStatus"
      @updateSignStatus="updateSignStatus"
    ></task>
    <rankingList
      :paiming="state.paiming"
      :rankList="state.ranking"
    ></rankingList>

    <img
      src="../../../assets/webActivity/newYear/newyear_rule.png"
      alt=""
      class="rule"
      @click="openPop('rule')"
    />
    <img
      src="../../../assets/webActivity/newYear/newyear_award.png"
      alt=""
      class="award"
      @click="openPop('award')"
    />

    <van-popup
      v-model:show="state.ruleFlag"
      :style="{ background: 'transparent' }"
    >
      <div class="rule_content">
        <img
          src="../../../assets/webActivity/newYear/newyear_rule_title.png"
          alt=""
        />
        <div class="content_info">
          <h4>活动时间：5月1日00:00-5月3日23:59</h4>
          <div class="declare">
            <p>
              1、活动期间玩家通过App进入活动页，通过签到或完成指定任务，可获得宝箱，一个宝箱可开启一次，开箱有机会抽取积分、优惠券（折前）、赠送余额奖励，优惠券领取后7天内有效；
            </p>
            <p>2、任意登录一款游戏可获得1个宝箱，活动期间只能完成一次；</p>
            <p>
              3、开通月卡会员可获得3次开箱机会，活动期间只能完成一次；
            </p>
            <p>
              4、在平台0.1、0.05折游戏（其他版本不支持）内通过支付宝、微信和充值余额充值任意金额、充值累计50元（折后实付）、300元（折后实付）可分别获得1个宝箱、8个宝箱和50个宝箱，活动期间只能分别完成一次该任务；
            </p>
            <p>
              5、在平台0.1、0.05折游戏（其他版本不支持）内通过支付宝、微信和充值余额每充值6元（折后实付）可领取1个宝箱，活动期间该任务可重复完成，（例如：活动期间充值40元，可领取6个宝箱，剩余金额如未达6元则无法获取宝箱，领取宝箱后则重新计算）；
            </p>
            <p>
              6、活动期间内获取的宝箱仅限同一用户消耗使用（同实名、手机号、设备、符合任意一条均视为同一用户）
            </p>
            <p>7、活动结束后宝箱将会自动清除，请在活动期间内使用；</p>
            <p>
              8、参与活动中有任何疑问，请联系在线客服咨询，最终解释权归属0.01折手游App。
            </p>
          </div>
          <img
            src="../../../assets/webActivity/newYear/newyear_know_btn.png"
            alt=""
            @click="state.ruleFlag = false"
          />
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model:show="state.awardFlag"
      :style="{ background: 'transparent' }"
      @open="openRecord"
      @close="closeRecord"
    >
      <div class="award_content">
        <img
          src="../../../assets/webActivity/newYear/newyear_award_title.png"
          alt=""
        />
        <img
          src="../../../assets/webActivity/newYear/newyear_close.png"
          alt=""
          class="close"
          @click="state.awardFlag = false"
        />
        <div class="content_info">
          <h4>获取的积分可前往首页签到处兑换</h4>
          <div class="award_list">
            <van-list
              v-model:loading="state.loading"
              :finished="state.finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell
                v-for="(item, i) in state.recordList"
                :key="i + '-list'"
              >
                <template #value>
                  <p>{{ item.lottery_log_cont }}</p>
                  <span>{{ dateYMDHM(item.lottery_log_time) }}</span>
                </template>
              </van-cell>
            </van-list>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import { onMounted, nextTick, reactive } from "vue";
import lottery from "./components/lottery.vue";
import task from "./components/task.vue";
import rankingList from "./components/rankingList.vue";
import { getQueryString } from "@/utils/location";
import { dateYMDHM } from "@/utils/date";
import { setToken } from "@/utils/auth";

const state = reactive({
  uid: "",

  // 当前第几天
  nowday: 1,
  // 当前排名
  paiming: {
    num: 0,
    name: "",
    paiming: "-",
  },
  // 总排行榜
  ranking: [],
  // 签到奖励
  signReward: [],
  // 任务列表
  taskList: [],
  // 第一名
  first: {},
  // 剩余抽奖次数
  cjnum: 0,

  // 规则弹窗，
  ruleFlag: false,
  // 奖励弹窗
  awardFlag: false,
  // 抽奖弹窗
  show: false,

  // 抽奖记录的一些状态
  finished: false,
  loading: true,
  recordList: [],
});

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  state.uid = getQueryString("uid");
  nextTick(async () => {
    await getList();
    // await getRecord();
  });
});

import { getNewYearList } from "@/api/activity";
import { Toast } from "vant";

const getList = async () => {
  try {
    let res = await getNewYearList({
      uid: state.uid,
    });
    console.log("新年活动数据", res.data);
    if (res.data.code == 1) {
      state.nowday = res.data.data.nowday;
      state.paiming = res.data.data.paiming;
      state.ranking = res.data.data.ranking;
      state.signReward = res.data.data.rewardlists;
      state.taskList = res.data.data.tasklists;
      state.cjnum = res.data.data.cjnum;

      // 排行榜第一的数据
      if (state.ranking.length > 0) {
        state.first = state.ranking[0];
      }
    } else {
      Toast(res.data.msg);
    }
    // console.log("获取新年活动数据", state);
  } catch (error) {
    Toast(error);
  }
};

// 刷新
const reloadTask = () => {
  getList();
};

const scrollTofirst = () => {
  let lotteryEle = document.querySelector(".lottery_content");
  let taskELe = document.querySelector(".task_content");
  let allEle = document.querySelector(".content");
  allEle.scrollTo({
    top: lotteryEle.clientHeight + taskELe.clientHeight,
    behavior: "smooth", // 平滑滚动
  });
};

// 更新抽奖次数
const updateCjnum = (num) => {
  state.cjnum = state.cjnum + num;
};
// 减少抽奖次数
const subtractCjnum = (num) => {
  state.cjnum = state.cjnum - num;
};

//更新抽奖任务状态
const updateTaskStatus = (id) => {
  state.taskList.find((item) => {
    if (item.id == id) {
      item.finished = 1;
    }
  });
};
// 更新日常任务状态
const updateSignStatus = (id) => {
  state.signReward.find((item) => {
    if (item.id == id) {
      item.status = 1;
    }
  });
};

const openPop = (type) => {
  console.log("打开弹窗", type);
  if (type == "rule") {
    state.ruleFlag = true;
  } else if (type == "award") {
    state.awardFlag = true;
  }
};

// 打开抽奖记录
const openRecord = async () => {
  pagecode = 1;
  state.recordList = [];
  state.finished = false;
  state.loading = true;
  await getRecord();
};
const closeRecord = async () => {
  pagecode = 1;
  state.recordList = [];
  state.finished = false;
  state.loading = true;
};
// 获取抽奖爱记录
import { getNewYearRecord } from "@/api/activity";
var pagecode = 1;

const onLoad = async () => {
  // console.log("分页--------加载更多");
  pagecode++;
  await getRecord();
};
const getRecord = async () => {
  try {
    let res = await getNewYearRecord({
      uid: getQueryString("uid"),
      page: pagecode,
    });
    if (res.data.code == 1) {
      state.recordList = state.recordList.concat(res.data.data.lists);
      if (pagecode >= res.data.data.total_page) {
        state.finished = true;
      }
      // console.log("抽奖记录", state.recordList);
    } else {
      state.finished = true;
      state.loading = false;
    }
    state.loading = false;

    console.log("抽奖记录", res);
  } catch (error) {}
};
</script>

<style src="../../../styles/removeVantcell.css"></style>
<style scoped>
.content {
  height: 100vh;
  overflow: auto;
}

.rule,
.award {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 99;
  width: 54px;
  height: 104px;
}

/* 规则 */
.rule {
  top: 40%;
}
/* 奖励 */
.award {
  top: 50%;
  height: 130px;
}

.rule_content > img,
.award_content > img {
  width: 276px;
  height: 80px;
  margin-bottom: 20px;
}
.rule_content,
.award_content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rule_content .content_info,
.award_content .content_info {
  background-image: url(../../../assets/webActivity/newYear/newyear_pop_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 686px;
  height: 870px;
  overflow: hidden;
  padding: 40px;
}
.content > :deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.8);
}
/* 规则 */
.rule_content {
  color: #822813;
  font-size: 28px;
}
.rule_content h4 {
  margin-bottom: 10px;
}
.rule_content .content_info {
  padding-bottom: 206px;
}
.rule_content .content_info .declare {
  height: 100%;
  overflow: auto;
  scrollbar-width: none;
}
.rule_content .content_info img {
  width: 460px;
  height: 130px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 15px;
}
/* 奖励 */
.award_content {
  position: relative;
}
.award_content .close {
  position: absolute;
  right: 0;
  top: 15px;
  width: 64px;
  height: 64px;
}
.award_content .content_info h4 {
  color: #822813;
  font-size: 24px;
  margin-bottom: 34px;
}
.award_content .content_info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.award_content .content_info .award_list {
  width: 100%;
  height: 760px;
  overflow: auto;
  scrollbar-width: none;
}
.award_content .content_info .award_list :deep(.van-cell__value) {
  width: 100%;
  height: 72px;
  background: #f8f8f8;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 8px;
}
.award_content .content_info .award_list :deep(.van-cell__value) p {
  font-size: 32px;
  color: #333333;
  font-weight: 700;
}
.award_content .content_info .award_list :deep(.van-cell__value) span {
  font-size: 24px;
  color: #707070;
}
</style>
